export default __webpack_public_path__ + "static/media/Flag_of_North_Macedonia.02122dd3.svg";